module.exports = __webpack_public_path__ + "static/social_cv-1c25f131cc7e59df49c4ccf54ee5b925.jpg";